import { OnboardingMilestone } from 'api/types';
import { OnboardingStep } from 'modules/types/util';

// Map OnboardingMilestone to the last completed OnboardingStep
export const getLastCompletedStep = (
  milestone: OnboardingMilestone | null,
): OnboardingStep | null => {
  switch (milestone) {
    case OnboardingMilestone.PRE_INSTALLATION:
      return OnboardingStep.INTRODUCTION;
    case OnboardingMilestone.SYSTEM_INSTALLATION:
      return OnboardingStep.PRE_INSTALLATION;
    case OnboardingMilestone.SYSTEM_ACTIVATION:
      return OnboardingStep.SYSTEM_INSTALLATION;
    case OnboardingMilestone.ONBOARDING_COMPLETE:
      return OnboardingStep.SYSTEM_ACTIVATION;
    default:
      return null; // No steps completed yet
  }
};

export default getLastCompletedStep;
